import type { DATE_FORMATS } from './constants/formats';

export type DateInput = string | number | Date;
export type TimezoneString = string;
export type Locale = string;
export type FormatString = keyof typeof DATE_FORMATS | string;

export interface DateTimeConfig {
  timezone?: TimezoneString;
  locale?: Locale;
}

export interface DurationComponents {
  years?: number;
  months?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

/** Clock display mode for schedule UI and `preferredTimeFormat` (localStorage). */
export enum TimeFormat {
  '24hr' = '24hr',
  ampm = 'ampm',
}
